export class AcessoExterno {
    codigoAcesso: string;
    chaveAcesso: string;
    erros: Number;
    dataGeracaoAcesso: Date;
    token : string | null;
    cpf: string
    email: string
    urlDestino : string;
    idAssinante: string;
    respostaRecaptcha: string;
    cookiesConsent: boolean;
    codeGovBr: string;
    urlGovBr: string;
}
